/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Tabs,
  useMediaQuery,
  Typography,
  Link,
} from "@mui/material";
import theme from "assets/theme";
import { useEffect, useMemo, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import { AlertState } from "states";
import CustomFieldForm from "../../components/CustomFieldForm";
import {
  PaperComponent,
  API_URL_DOWNLOAD,
  checkUrlTep,
} from "../../utils/constants";
import CustomTabPanel from "components/CustomPanel/customPanel";
import { JsonTool } from "utils/jsonTools";
import BusinessIcon from "@mui/icons-material/Business";
import ArticleIcon from "@mui/icons-material/Article";
import { DownloadIcon } from "@primer/octicons-react";

const defaultValue = {
  nam: new Date(),
  chuthe: null,
  landanhgia: 1,
  ngaydanhgia: null,
  noidung: "",
  sanpham: null,
  username: null,
  hoidong: null,
  noidung_nguongoc: "",
  noidung_ytuong: "",
  noidung_laodong: "",
  noidung_bansac: "",
  noidung_khac: "",
};

const FormDanhGiaHoSo = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  fieldInfor,
}) => {
  // state lỗi giá trị từ form
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const formRef = useRef(null);
  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);
  const [alert, setAlert] = useRecoilState(AlertState);

  const [value, setValue] = useState(0);

  const fieldInforNoidung = useMemo(() => {
    let result = [
      {
        name: "Sử dụng nguyên liệu địa phương",
        key: "noidung_nguongoc",
        type: "textArea",
        required: true,
        maxLength: 1000,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Nguồn gốc ý tưởng sản phẩm",
        key: "noidung_ytuong",
        type: "textArea",
        required: true,
        maxLength: 1000,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Sử dụng lao động địa phương",
        key: "noidung_laodong",
        type: "textArea",
        required: true,
        maxLength: 1000,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Bản sắc/trí tuệ địa phương",
        key: "noidung_bansac",
        type: "textArea",
        required: true,
        maxLength: 1000,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Nội dung khác",
        key: "noidung_khac",
        type: "textArea",
        maxLength: 1000,
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);

  useEffect(() => {
    if (data && data.id) {
      let dataConvert = {
        ...data,
        index: data?.rowIndex,
        id: data?.id,
        noidung_nguongoc: data?.noidung_nguongoc,
        noidung_ytuong: data?.noidung_ytuong,
        noidung_laodong: data?.noidung_laodong,
        noidung_bansac: data?.noidung_bansac,
        noidung_khac: data?.noidung_khac,
      };
      setDataState(dataConvert);
    } else {
      setDataState(defaultValue);
    }
  }, [data]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    _data["id"] = data?.id;
    _data["rowIndex"] = data?.rowIndex;
    _data["hoidong"] = "";
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    onSubmit(_data);
  }

  const handelClear = () => {
    onClose();
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors({});
    }
  }, [open]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "40rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <form
        ref={formRef}
        method="post"
        encType="multipart/form-data"
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          {title ? title : "Đánh giá một số nội dung hồ sơ đăng ký"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
          <Box>
            {/* show lỗi từ khi không xác định được từ các field ở form */}
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            <Box
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                //borderBottom: 1,
                borderColor: "divider",
                padding: "0 1rem",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="secondary"
                textColor="primary"
                variant="fullWidth"
                aria-label="basic tabs example"
              >
                <Tab
                  icon={<BusinessIcon />}
                  label="Thông tin hồ sơ đăng ký"
                  {...JsonTool.a11yProps(0)}
                />
                <Tab
                  icon={<ArticleIcon />}
                  label="Nội dung đánh giá"
                  {...JsonTool.a11yProps(1)}
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Grid
                container
                spacing={1}
                border={"2px solid #d6d6d6"}
                sx={{ borderRadius: "0.5rem" }}
              >
                {fieldInfor &&
                  fieldInfor.length > 0 &&
                  fieldInfor.map((item) => (
                    <Grid
                      item
                      xs={item?.xs}
                      md={item?.md}
                      lg={item?.lg}
                      key={item?.key + "inforField"}
                      sx={{
                        borderBottom: "1px solid #d6d6d6",
                        borderRight: "1px solid #d6d6d6",
                      }}
                    >
                      <Typography fontSize={"0.75rem"} fontWeight={"500"}>
                        {item?.name}:
                      </Typography>
                      <Typography fontSize={"1rem"}>
                        {data?.[item?.key]
                          ? data?.[item?.key]
                          : "Đang cập nhập ..."}
                      </Typography>
                    </Grid>
                  ))}
              </Grid>
              {data &&
                data.id &&
                (data.tepdinhkem_phieudangky &&
                data.tepdinhkem_phieudangky.length > 0 ? (
                  <Grid container marginTop={"10px"} spacing={1}>
                    <Grid
                      container
                      style={{
                        color: "#000000",
                        backgroundColor: "rgb(142 199 243)",
                      }}
                      fontSize={"1rem"}
                      fontWeight={600}
                      m={"0.5rem 0"}
                      spacing={1}
                      borderBottom={"2px solid #3F51B5"}
                    >
                      <Grid item xs={2}>
                        STT
                      </Grid>
                      <Grid item xs={8}>
                        Tên tệp đính kèm
                      </Grid>
                      <Grid item xs={2}>
                        Tải về
                      </Grid>
                    </Grid>
                    {data.tepdinhkem_phieudangky?.map((tep, index) => (
                      <Grid
                        container
                        key={tep?.id + index}
                        style={{ color: "#000000" }}
                        fontSize={"1rem"}
                        borderBottom={"1px solid #d6d6d6"}
                        pb={"0.5rem"}
                        mb={"0.5rem"}
                        ml={0}
                        spacing={1}
                      >
                        <Grid item xs={2}>
                          {index + 1}
                        </Grid>
                        <Grid item xs={8}>
                          {tep?.tentepdinhkem}
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          style={{ paddingTop: "0px" }}
                        >
                          <Typography variant="h5" color="info">
                            <Link
                              target="_blank"
                              href={
                                API_URL_DOWNLOAD + checkUrlTep(tep?.tepdinhkem)
                              }
                            >
                              <DownloadIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    p="1rem"
                    height="100%"
                  >
                    <Typography
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "500",
                        lineHeight: "1.5rem",
                        color: "black",
                      }}
                    >
                      Không có thông tin Tệp đính kèm
                    </Typography>
                  </Grid>
                ))}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              {fieldInforNoidung?.length > 0 && (
                <CustomFieldForm
                  key={"fieldInforNoidung"}
                  listField={fieldInforNoidung}
                  data={dataState}
                  onChange={handleChangeDataState}
                  onError={handleErrorDataState}
                  errorValues={errors}
                />
              )}
            </CustomTabPanel>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={onSubmitForm}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Lưu
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};
function validateOBJ(dg) {
  let result = {
    noidung_nguongoc: !validateRequired(dg.noidung_nguongoc)
      ? "Nhập nội dung nguồn gốc sản phẩm"
      : "",
    noidung_ytuong: !validateRequired(dg.noidung_ytuong)
      ? "Nhập nội dung nguồn gốc ý tưởng sản phẩm"
      : "",
    noidung_laodong: !validateRequired(dg.noidung_laodong)
      ? "Nhập nội dung sử dụng lao động địa phương"
      : "",
    noidung_bansac: !validateRequired(dg.noidung_bansac)
      ? "Nhập nội dung bản sắc/trí tuệ địa phương"
      : "",
  };
  return result;
}
export default FormDanhGiaHoSo;
